<template>
  <article
    class="bg-color-white border-r-20 px-4 pb-3 pt-4 position-relative"
    id="customerCommentCard"
  >
    <div class="mx-auto avatr">
      <img class="w-100 h-100" :src="comment.img" :alt="comment.author" />
    </div>
    <h3 class="font-w-800 font-s-16 text-color-theme-dark text-center mt-4">
      {{ comment.author }}
    </h3>
    <div class="d-flex align-items-center justify-content-center gap-5">
      <StarSvg v-for="i in 5" :key="i" />
    </div>
    <p
      class="font-w-400 fonr-s-10 text-color-theme-dark text-center line-height2 mt-3"
    >
      {{ comment.description }}
    </p>
    <Quote class="quote-icon position-absolute" />
  </article>
</template>
<script>
import StarSvg from "@/parts/Front/components/Icon/StarSvg.vue";
import Quote from "@/parts/Front/components/Icon/Quote.vue";
export default {
  components: {
    StarSvg,
    Quote,
  },
  props: {
    comment: {
      type: Object,
    },
  },
};
</script>
<style scoped>
#customerCommentCard {
  box-shadow: 0px 0px 48.08122253417969px 6.497462272644043px #bababa63;
  overflow: hidden;
}
#customerCommentCard .avatr {
  width: 82px;
  height: 82px;
  border-radius: 50%;
  overflow: hidden;
}
#customerCommentCard .quote-icon {
  top: -3%;
  right: 0%;
  border-radius: 30% 79% 21% 79% / 55% 25% 75% 45%;
  background-color: var(--color-theme3);
  padding: 25px 10px 12px 9px;
  width: 77px;
  height: 77px;
}
</style>
